import React, {
    useCallback,
    useEffect,
    useState,
    useRef
} from "react";
import classnames from "classnames";
import "./styles.scss";

const MultiRangeSlider = ({
                              min,
                              max,
                              onChange,
                              v1,
                              v2
                          }) => {
    const [minVal, setMinVal] = useState(v1 || min);
    const [maxVal, setMaxVal] = useState(v2 || max);
    const minValRef = useRef(null);
    const maxValRef = useRef(null);
    const range = useRef(null);

    useEffect(() => {
        setMinVal(v1 || min);
        setMaxVal(v2 || max);
    }, [v1, v2]);

    const getPercent = useCallback(
        (value) => Math.round(((value - min) / (max - min)) * 100),
        [min, max]
    );

    useEffect(() => {
        if (maxValRef.current) {
            const minPercent = getPercent(minVal);
            const maxPercent = getPercent(+maxValRef.current.value);

            if (range.current) {
                range.current.style.left = `${minPercent}%`;
                range.current.style.width = `${maxPercent - minPercent}%`;
            }
        }
    }, [minVal, getPercent]);

    useEffect(() => {
        if (minValRef.current) {
            const minPercent = getPercent(+minValRef.current.value);
            const maxPercent = getPercent(maxVal);

            if (range.current) {
                range.current.style.width = `${maxPercent - minPercent}%`;
            }
        }
    }, [maxVal, getPercent]);

    return (
        <div className="dual-range-slider">
            <input
                type="range"
                min={min}
                max={max}
                value={minVal}
                ref={minValRef}
                onChange={(event) => {
                    const value = Math.min(+event.target.value, maxVal - 1);
                    setMinVal(value);
                    event.target.value = value.toString();
                    onChange({min: value, max: maxVal});
                }}
                className={classnames("thumb thumb--zindex-3", {
                    "thumb--zindex-5": minVal > max - 100
                })}
            />
            <input
                type="range"
                min={min}
                max={max}
                value={maxVal}
                ref={maxValRef}
                onChange={(event) => {
                    const value = Math.max(+event.target.value, minVal + 1);
                    setMaxVal(value);
                    event.target.value = value.toString();
                    onChange({min: minVal, max: value});
                }}
                className="thumb thumb--zindex-4"
            />

            <div className="slider">
                <div className="slider__track"></div>
                <div ref={range} className="slider__range"></div>
            </div>
        </div>
    );
};

export default MultiRangeSlider;


// WEBPACK FOOTER //
// ./App/components/DualRangeSlider/index.jsx